<template>
  <component   :is="isComponent"></component>
</template>
<script>
import giveShare from "@/views/course/give_share/index"
import discoveryGiveShare from "@/views/course2/give_share/index"

export default {
  data() {
      return {
        isComponent:'',
        bid: ''
      }
    },
    components: {
      giveShare,
      discoveryGiveShare
    },
    methods: {
      /*
     *@param: bid
     *@return:
     *@Description: 根据路由上的bid判断 1 个人战略  2自我探索
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-09-26 14:47:48
     */
      pullData() {
        let querys = this.$route.query;
        if(querys.bid==1){
          this.isComponent = giveShare
        }
        if(querys.bid==2){
          this.isComponent = discoveryGiveShare
        }
      }
    },
    created() {
      this.pullData();
    },
}
</script>